import { GetterTree } from 'vuex';
import { MasterState } from '@/store/master/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters : GetterTree<MasterState, RootState> = {
  /**
   * 大学コードを元に大学情報を取得する
   * @param {string} code 大学コード
   */
  findUniversityByCode: (state) => (code: string) => _.find(state.universities, { code }),

  /**
   * キャンパスコードを元にキャンパス情報を取得する
   * @param {string} code キャンパスコード
   */
  findCampusByCode: (state) => (code: string) => _.find(state.campuses, { code }),

  /**
   * 学期コードを元に学期情報を取得する
   * @param {string} code 学期コード
   */
  findSemesterByCode: (state) => (code: string) => _.find(state.semesters, { code }),

  /**
   * レベルコードを元にレベル情報を取得する
   * @param {string} code レベルコード
   */
  findLevelByCode: (state) => (code: string) => _.find(state.levels, { code }),

  /**
   * 休暇理由コードを元に休暇理由情報を取得する
   * @param {string} code 休暇理由コード
   */
  findVacationReasonByCode: (state) => (code: string) => _.find(state.vacationReasons, { code }),
};

export default getters;
